import { Guid } from "@/types"
import Notification, { IGetNotification, NotificationType } from "./Notification"

export interface IGetNotificationReservationCanceledDto extends IGetNotification {
    notificationType: NotificationType.reservationCanceled
    reservationId: Guid
    number: string
    reason: string
}

export default class NotificationReservationCanceled extends Notification {
    reservationId: Guid
    number: string
    reason: string

    constructor(dto: IGetNotificationReservationCanceledDto) {
        super(dto)
        this.reservationId = dto.reservationId
        this.number = dto.number
        this.reason = dto.reason
    }
}
